import * as React from 'react';
import { useRouteError } from 'react-router-dom';
import { Button } from '@sparta/ui-kit';

export function ErrorPage(): React.ReactElement {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : 'Unknown error';

  return (
    <main
      role="alert"
      aria-live="assertive"
      className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-4 text-center"
    >
      <h1 className="text-2xl font-semibold text-neutral-900">
        Something went wrong
      </h1>
      <p className="mt-2 text-sm text-neutral-700">{message}</p>
      <Button
        onClick={() => window.location.reload()}
        className="mt-4"
        variant="secondary"
      >
        Reload
      </Button>
    </main>
  );
}
